import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "ui-button__leading"
}
const _hoisted_3 = {
  key: 1,
  class: "ui-button__label"
}
const _hoisted_4 = {
  key: 2,
  class: "ui-button__trailing"
}

import { computed } from 'vue';

type ButtonType = 'button' | 'submit' | 'reset';
type ButtonVariant = 'solid' | 'ghost' | 'soft';
type ButtonTone = 'neutral' | 'primary' | 'danger';
type ButtonSize = 'sm' | 'md';


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    type: { default: 'button' },
    variant: { default: 'solid' },
    tone: { default: 'neutral' },
    size: { default: 'md' },
    iconOnly: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const buttonClasses = computed(() => [
  'ui-button',
  `ui-button--${props.variant}`,
  `ui-button--${props.tone}`,
  `ui-button--${props.size}`,
  {
    'ui-button--icon-only': props.iconOnly,
    'ui-button--block': props.block
  }
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.type,
    disabled: __props.disabled,
    class: _normalizeClass(buttonClasses.value)
  }, [
    (_ctx.$slots.leading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "leading")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.$slots.trailing)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _renderSlot(_ctx.$slots, "trailing")
        ]))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})